import { lazy } from "react";

export { SALES_FUNNEL_PATH } from "./path";
export const SalesFunnelPage = lazy(() => import("./page"));
